import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class HeaderV2 extends Component {
  render() {
    if (this.props.user.student_info) {
      return (
        <>
          <div
            className="shadow-sm fixed-top d-flex justify-content-between container col-12 py-2 bg-white"
            style={{
              zIndex: 10,
              maxWidth: "500px",
            }}
          >
            <div className="d-flex">
              <Link to="/aboutSchool">
                <div
                  className="p-4"
                  style={{
                    backgroundImage: `url(${this.props?.user?.user?.school?.logo})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                  }}
                ></div>
              </Link>

              <div className="pl-3 my-auto">
                <h6 className=" th-14 mb-0">
                  {this.props?.user?.user?.school?.school_name}
                </h6>
                <p className=" th-12 mb-0">{this.props?.title}</p>
              </div>
            </div>

            <Link
              className="th-link-headerV2 th-20 my-auto px-2 py-1"
              to={
                this.props?.user?.role?.id === 9
                  ? `/notifications`
                  : "/tnotifications"
              }
            >
              <i className="fa fa-bell-o" aria-hidden="true"></i>
            </Link>
          </div>
        </>
      );
    } else {
      return "";
    }
  }
}
export default connect(mapStateToProps)(HeaderV2);
